import AppLayout from "../layouts/app.layout";

export default function IndexPage() {
  return <AppLayout></AppLayout>;
}
